module.exports = __webpack_public_path__ + "static/media/naver.a7361787.svg";